__webpack_require__.p = "/seminar/";